import React, {useEffect, useState} from 'react';
import './MenuDemoLoader.css';

/**
 * Лоадер демо-партии главного меню: кольцо из шести гексов, стоящих сторона
 * к стороне (с зазором 4px). Гексы по очереди проявляются по opacity (первый —
 * road — сверху, остальные по часовой стрелке), после проявления последнего
 * в том же порядке затухают; цикл бесконечный (чистая CSS-анимация).
 * Лоадер появляется только после предзагрузки всех изображений гексов, чтобы
 * анимация не мелькала пустыми местами. Когда поле загружено, родитель
 * передает isHiding — весь лоадер плавно затухает и затем размонтируется
 * по таймеру.
 */

// Гексы плоской (flat-top) формы, 500x434: соседи кольца лежат на окружности
// с радиусом, равным высоте гекса; центр первого строго сверху (угол 90°),
// далее с шагом 60° по часовой стрелке
const LOADER_HEXES = [
  {src: '/img/hexes/road.1f281346.png', dx: 0, dy: -1},
  {src: '/img/hexes/quarter.f69660fa.png', dx: 0.866, dy: -0.5},
  {src: '/img/hexes/farm.699e6dfc.png', dx: 0.866, dy: 0.5},
  {src: '/img/hexes/barracks.efab12f7.png', dx: 0, dy: 1},
  {src: '/img/hexes/mine.ecae90cd.png', dx: -0.866, dy: 0.5},
  {src: '/img/hexes/ruins.65862e11.png', dx: -0.866, dy: -0.5},
];

const MenuDemoLoader = ({isHiding, text = 'Запускаем демо...', isCompact}) => {
  const [areImagesLoaded, setAreImagesLoaded] = useState(false);

  useEffect(() => {
    let isCancelled = false;
    let settledCount = 0;
    // Ошибка загрузки тоже завершает ожидание: лучше лоадер без одной
    // картинки, чем вечно скрытый лоадер
    LOADER_HEXES.forEach((hex) => {
      const image = new Image();
      // Дублирует <link rel="preload"> из index.html на случай, если HTML
      // закэширован старой версии; запросы по тому же URL объединяются
      image.fetchPriority = 'high';
      image.onload = image.onerror = () => {
        settledCount += 1;
        if (!isCancelled && settledCount === LOADER_HEXES.length) {
          setAreImagesLoaded(true);
        }
      };
      image.src = hex.src;
    });
    return () => {
      isCancelled = true;
    };
  }, []);

  if (!areImagesLoaded) {
    return null;
  }

  return (
    <div
      className={`menu-demo-loader${isHiding ? ' menu-demo-loader_hiding' : ''}${isCompact ? ' menu-demo-loader_compact' : ''}`}
    >
      <div className="menu-demo-loader-ring">
        {LOADER_HEXES.map((hex, index) => (
          <img
            key={hex.src}
            className="menu-demo-loader-hex"
            src={hex.src}
            alt=""
            style={{'--hex-index': index, '--hex-dx': hex.dx, '--hex-dy': hex.dy}}
          />
        ))}
      </div>
      <span className="menu-demo-loader-text">{text}</span>
    </div>
  );
};

export default MenuDemoLoader;
